import { render, staticRenderFns } from "./DataMonitor.vue?vue&type=template&id=63c73835&scoped=true"
import script from "./DataMonitor.vue?vue&type=script&lang=js"
export * from "./DataMonitor.vue?vue&type=script&lang=js"
import style0 from "./DataMonitor.vue?vue&type=style&index=0&id=63c73835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c73835",
  null
  
)

export default component.exports